// Localization (Phase 3). The bracket labels live in the bundled `common`
// catalog (src/locales/en/common.json), because this module is reached by
// the entry chunk (BracketBadge on the home page) and every page loads it:
// - `common:bracket_name.<n>` and `common:bracket_label` (was BRACKET_NAMES)
// - `common:turn_not_available`
// The engine and strategy labels and definitions live in the lazily shipped
// `bracket` catalog and are served by ./engineLabels.ts. Do NOT import that
// module (or src/i18n/ns/bracket) from here: it would put the whole `bracket`
// English into the shared chunk every page preloads, which
// scripts/check-i18n-bundle.mjs fails.
import i18n, { codeLabel, formatDecimal1 } from '../i18n'

// Players talk in bracket numbers, not WotC marketing names.
// Only cEDH stays as a name because that's what the community uses.
// (`common:bracket_name.5`; every other bracket reads `common:bracket_label`.)

// The 16 canonical engine families, in display order, for the Library's
// engine filter chips. Matches the engine_family values computed by the
// public_decks view (the SQL CASE there is the single authoritative mapping
// from raw engine strings; clients only filter on the result). Deliberately
// NOT derived from the `bracket:engine` catalog family, which mixes canonical, legacy, and
// strategy keys.
export const ENGINE_FAMILY_KEYS = [
  'tribal', 'spellslinger', 'landfall', 'artifacts', 'graveyard', 'control',
  'tokens', 'counters', 'sacrifice', 'blink', 'combat', 'lifegain',
  'enchantress', 'treasure', 'wheels', 'cheat',
] as const

/** snake_case or kebab-case code to Title Case ("big_mana" to "Big Mana"). */
export function titleCase(value: string): string {
  return value.replace(/[-_]/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
}

export function formatBracket(bracket: number): string {
  return codeLabel('common', 'bracket_name', String(bracket)) ?? i18n.t('common:bracket_label', { bracket })
}

export function formatTurn(turn: number | null | undefined): string {
  if (turn == null) return i18n.t('common:turn_not_available')
  return `~${formatDecimal1(turn)}`
}

export function formatConfidence(confidence: number): string {
  return `${Math.min(100, Math.round(confidence * 100))}%`
}
